import { VersionHistoryPanel } from "../../../components/drawing-tool/version-history";
import { CommonModal } from "../../../components";

interface ProductSummaryHistorySheetProps {
  visibleModal: boolean;
  onClose: () => void;
  productId: string | undefined;
  salesUnitId: string | undefined;
  isAverageProduct: boolean;
  onVersionRestored?: () => void;
}

/** Thin sheet chrome around the shared VersionHistoryPanel -- see ProductSummaryHistory tab
 * (product/productDetails/ProductDetailsModal.tsx) for the other host of the same panel. */
const ProductSummaryHistorySheet = ({
  visibleModal,
  onClose,
  productId,
  salesUnitId,
  isAverageProduct,
  onVersionRestored
}: ProductSummaryHistorySheetProps) => (
  <CommonModal modalOpenState={visibleModal} modalCloseState={onClose} title="Product Summary History">
    <div className="tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-4">
      <VersionHistoryPanel
        productId={productId}
        salesUnitId={salesUnitId}
        isAverageProduct={isAverageProduct}
        onVersionRestored={onVersionRestored}
        heading={null}
      />
    </div>
  </CommonModal>
);

export default ProductSummaryHistorySheet;
